import { render, staticRenderFns } from "./UpdatePriceModal.vue?vue&type=template&id=0d546dad"
import script from "./UpdatePriceModal.vue?vue&type=script&lang=js"
export * from "./UpdatePriceModal.vue?vue&type=script&lang=js"
import style0 from "./UpdatePriceModal.vue?vue&type=style&index=0&id=0d546dad&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports